// Notification event constants - matches backend enum exactly

// **********************************************************************************
// IMPORTANT: MAKE SURE THAT BACKEND ENUM ALWAYS MATCH THIS EXACTLY
// IF YOU CHANGE THIS, YOU WILL NEED TO UPDATE THE BACKEND ENUM AS WELL
// **********************************************************************************

export const NOTIFICATION_EVENTS = {
    // Assignment Events
    EXTERNAL_ASSIGNED: 'EXTERNAL_ASSIGNED', // Internal PM/Super assigns deficiency to external subcontractor
    EXTERNAL_REASSIGNED: 'EXTERNAL_REASSIGNED', // Internal PM/Super reassigns deficiency to different external subcontractor

    // Update Events
    DUEDATE_UPDATE: 'DUEDATE_UPDATE', // Internal PM/Super changes due-date on externally-assigned deficiency

    // Rejection Events
    INTERNAL_REJECTION: 'INTERNAL_REJECTION', // Internal PM/Super rejects submitted defect or work-completed check
    EXTERNAL_REJECTION: 'EXTERNAL_REJECTION', // External user rejects completion
    WORK_REJECTED: 'WORK_REJECTED', // Internal PM rejects completed work, bouncing it back to the assigned company for rework

    // Status Change Events
    WORK_COMPLETED: 'WORK_COMPLETED', // External subcontractor marks deficiency Work Completed
    WORK_APPROVED: 'WORK_APPROVED', // Notification event: submitted work reached final completion approval
    SUBMITTED_DEF: 'SUBMITTED_DEF', // External Owner/Consultant submits a new deficiency
    EXTERNALLY_SIGNED_OFF: 'EXTERNALLY_SIGNED_OFF', // External user signs off completion

    // Scheduled Events (created by scheduler)
    DUEDATE_REMINDER: 'DUEDATE_REMINDER', // 2 days before due-date and work not complete
    INTERNAL_ESCALATION: 'INTERNAL_ESCALATION', // 5 days past due-date, trade = internal
    EXTERNAL_ESCALATION: 'EXTERNAL_ESCALATION', // 5 days past due-date, trade = external

    // Communication Events
    COMMENT_ADDED: 'COMMENT_ADDED', // New comment added to deficiency

    // Field Worker Request Events
    FIELD_WORKER_REQUEST_SUBMITTED: 'FIELD_WORKER_REQUEST_SUBMITTED', // External sub creates a field worker request
    FIELD_WORKER_REQUEST_APPROVED: 'FIELD_WORKER_REQUEST_APPROVED', // Internal user approves field worker request
    FIELD_WORKER_REQUEST_REJECTED: 'FIELD_WORKER_REQUEST_REJECTED', // Internal user rejects field worker request
};

// Event helper functions
export const isOverdueEvent = (eventKey) => {
    return [
        NOTIFICATION_EVENTS.INTERNAL_ESCALATION,
        NOTIFICATION_EVENTS.EXTERNAL_ESCALATION,
    ].includes(eventKey);
};

export const isReminderEvent = (eventKey) => {
    return eventKey === NOTIFICATION_EVENTS.DUEDATE_REMINDER;
};
